import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, inject } from "@angular/core";
import { ImageryLayer, ImageryLayerCollection, ImageryProvider } from "cesium";
import { CesiumMapService } from "../../services/cesium-map.service";

@Component({
    selector: "dtm-map-layer-provider",
    template: "",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapLayerProviderComponent<Options extends object> implements OnInit, OnChanges {
    @Input({ required: true }) public provider!: new (options: Options) => ImageryProvider;
    @Input() public alpha = 1.0;
    @Input() public brightness = 1.0;
    @Input() public contrast = 1.0;
    @Input() public index: number | undefined;
    @Input({ required: true }) public options!: Options;
    @Input({ transform: coerceBooleanProperty }) public shouldShow = true;

    public imageryLayersCollection: ImageryLayerCollection | undefined;
    public imageryLayer: ImageryLayer | undefined;
    public layerProvider: ImageryProvider | undefined;

    private cesiumMapService = inject(CesiumMapService);

    public ngOnInit(): void {
        if (!this.provider || !this.options) {
            throw new Error("Provider and options are required for MapLayerProviderComponent");
        }
    }

    protected rebuildLayer() {
        this.imageryLayersCollection ??= this.cesiumMapService.getScene().imageryLayers;

        this.layerProvider = new this.provider(this.options);
        if (this.imageryLayer) {
            this.imageryLayersCollection.remove(this.imageryLayer);
        }

        if (!this.shouldShow) {
            return;
        }
        this.imageryLayer = this.imageryLayersCollection.addImageryProvider(this.layerProvider, this.index);
        this.imageryLayer.alpha = this.alpha;
        this.imageryLayer.contrast = this.contrast;
        this.imageryLayer.brightness = this.brightness;
    }

    public ngOnChanges(): void {
        this.rebuildLayer();
    }
}
